import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-detail-comment-modal',
  templateUrl: './detail-comment-modal.component.html',
  styleUrl: './detail-comment-modal.component.scss',
})
export class DetailCommentModalComponent {
  open = input<boolean>(false);
  draft = input<string>('');
  saving = input<boolean>(false);
  error = input<boolean>(false);

  closed = output<void>();
  draftChanged = output<string>();
  saveRequested = output<void>();

  onInput(event: Event): void {
    this.draftChanged.emit((event.target as HTMLTextAreaElement).value);
  }
}
